import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f9fa55a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "custom-container d-flex flex-column"
};
const _hoisted_2 = {
  class: "d-flex flex-row align-items-center justify-content-between w-100"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow-1 mr-2 search-background"
}, null, -1));
const _hoisted_4 = {
  class: "content-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, $props.visibleButton ? (_openBlock(), _createBlock(_component_app_button, {
    key: 0,
    class: "",
    variant: "primary",
    V2: "",
    onClick: $options.onClick,
    disabled: !$props.activeButton,
    loading: $props.spinButton,
    shouldBeFocused: true
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
      icon: "add-new-ui"
    }), _createElementVNode("span", null, _toDisplayString($props.action), 1)])]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"])) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]);
}